// SHOW_SOCIAL_PROOF: the Google score and the lifetime wash count, on or off.
//
// Robin, 19 Oct 2026: "remove or hide for now google 4.1 rating and car wash
// total volume / number..". One switch, off by default, in config/deploy.yml
// env.clear (AppSecrets.show_social_proof?). The layout writes the
// `gwmc:social-proof` meta tag only while it is on; no tag is off, and every
// figure below reads as absent, fallback included. Turning it back on is a
// deploy, not a code change.

export const showSocialProof = () => {
  if (typeof document === 'undefined') return false
  return document.querySelector('meta[name="gwmc:social-proof"]')?.getAttribute('content') === 'on'
}

// The lifetime wash count as the copy prints it ("26,093"), or null while the
// switch is off. A count under 1,000 is a cold cache or a seeded database, so
// it falls back to 26,000+, which is true.
export const washCountLabel = config => {
  if (!showSocialProof()) return null
  const count = config?.TOTAL_COMPLETED_WASHES
  return typeof count === 'number' && count >= 1000 ? count.toLocaleString('en-GB') : '26,000+'
}
